import type { ProductBadgeModel } from '@/models/product-badge-model';

/** Each badge (by key) once, in the order the badges first appear. */
export function getUniqueProductBadges(badges: ProductBadgeModel[]): ProductBadgeModel[] {
  const badgeByKey = new Map<string, ProductBadgeModel>();
  badges.forEach((badge) => {
    if (!badgeByKey.has(badge.key)) {
      badgeByKey.set(badge.key, badge);
    }
  });

  return Array.from(badgeByKey.values());
}
